module.exports = __webpack_public_path__ + "img/Pink_Mixed.fbf8626e.png";